import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { MarkedList } from 'apps/auth/components/common/MarkedList/MarkedList';
import { MarkedListItem } from 'apps/auth/components/common/MarkedList/MarkedListItem';

const KycGuideScreen = ({ primaryButtonOnClick, title, subTitle, caption, chatTitle, toggleChat, href = '#', items = [] }) => {
    return (
        <>
            <HeaderPanel title={title} subtitle={subTitle} />
            <Row indent="adaptive-32-48">
                <MarkedList>
                    {items.map((item) => (
                        <MarkedListItem text={item} key={item} />
                    ))}
                </MarkedList>
            </Row>
            <Button type="button" size="tight" variant="row" caption={chatTitle} onClick={() => toggleChat(true)} negativeMargin />
            <FixedBottomPanel isRightAligned>
                <Button type="link" href={href} raised={true} caption={caption} onClick={primaryButtonOnClick} />
            </FixedBottomPanel>
        </>
    );
};
KycGuideScreen.propTypes = {
    primaryButtonOnClick: PropTypes.func,
    toggleChat: PropTypes.func,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    caption: PropTypes.string,
    chatTitle: PropTypes.string,
    items: PropTypes.array,
    href: PropTypes.string,
};
export default connect(null, { toggleChat })(KycGuideScreen);
